<template>
    <div class="section top-bar">
        <div class="logo-wrapper">
            <router-link @click="toggleSidebar" :to="userHomeLink" class="logo">
              <o-icon pack="fa" icon="check"></o-icon>
              <span> Ordino</span>
            </router-link>
        </div>
        <div class="mobile-menu-button">
            <a class="mobile-menu" @click.prevent="toggleSidebar"><span class="icon is-medium"><i class="fa fa-bars"></i></span></a>
        </div>
        <div class="header-main">
            <div class="container is-fluid">
                <div class="columns is-mobile">
                    <div class="column is-6-mobile is-3-tablet is-4-desktop flex-vertical-center creation-dropdown-wrapper">
                        <creation-dropdown
                                @open-contact-modal="isContactModalActive = true"
                                @open-reminder-modal="isReminderModalActive = true"
                                @open-time-log-modal="isTimeLogModalActive = true"
                        />
                        <div class="notifications-dropdown">
                            <notification-dropdown/>
                        </div>
                    </div>
                    <div class="column is-hidden-mobile is-5-tablet is-4-desktop search-wrapper">
                        <search/>
                    </div>
                    <div class="column is-6-mobile is-4-tablet flex-right">
                        <profile-dropdown/>
                    </div>
                </div>
            </div>
        </div>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isContactModalActive" has-modal-card>
            <contact-modal/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTimeLogModalActive" has-modal-card>
            <time-log-modal/>
        </o-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import CreationDropdown from './CreationDropdown'
    import ProfileDropdown from './ProfileDropdown'
    import Search from './Search'
    import NotificationDropdown from './NotificationDropdown'

    export default {
        components: { CreationDropdown, ProfileDropdown, Search, NotificationDropdown },

        data () {
            return {
                isContactModalActive: false,
                isReminderModalActive: false,
                isTimeLogModalActive: false,
            }
        },

        methods: {
            ...mapActions({
                toggleSidebar: 'toggleSidebar',
            }),
        },

        computed: {
            ...mapGetters(['userHomeLink'])
        }
    }
</script>
